export default "__VITE_ASSET__6pqw5Etz__";